import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
export var getComboBoxTheme = function getComboBoxTheme(theme) {
  return ThemeFactory.create({
    menuOffsetY: theme.comboboxMenuOffsetY
  }, theme);
};